import { useSafeState } from 'ahooks';
import {
  OwnerAssetsCountType,
  PropertyInfo,
  UserInfo,
} from '@/pages/Mine/interface';
import { queryAccountInfo } from '@/service/banner';
import { useEffect } from 'react';

export default function useDefaultRoom() {
  // 排序完成的房间列表 默认房间在第一个
  const [roomList, setRoomList] = useSafeState<PropertyInfo[]>([]);
  // 默认房间
  const [defaultRoom, setDefaultRoom] = useSafeState<PropertyInfo>();
  // 业主信息
  const [ownerInformation, setOwnerInformation] = useSafeState<UserInfo>();

  const [bindInformation, setBindInformation] =
    useSafeState<OwnerAssetsCountType>();

  /**
   * 根据defaultFlag字段排序 默认房间在第一个
   * @param items
   */
  const sortByDefaultFlag = (items: PropertyInfo[]) => {
    return items.slice().sort((a, b) => {
      if (a.defaultFlag === '1' && b.defaultFlag !== '1') return -1;
      if (a.defaultFlag !== '1' && b.defaultFlag === '1') return 1;
      return 0;
    });
  };

  /**
   * 查询用户信息
   */
  const queryInformation = () => {
    queryAccountInfo().then((res) => {
      if (res?.code === 200) {
        const { owner, room, bind } = res.data;
        const defaultRoomData = room.find(
          (item: PropertyInfo) => item.defaultFlag === '1',
        );
        setRoomList(sortByDefaultFlag(room));
        setDefaultRoom(defaultRoomData);
        setOwnerInformation(owner);
        setBindInformation(bind);
      }
    });
  };

  useEffect(() => {
    // 为了防止数据不准确，在引入这个hooks时先获取最新的用户和房屋信息信息
    queryInformation();
  }, []);

  return {
    /**
     * 房间列表
     */
    roomList,
    /**
     * 默认房间信息
     */
    defaultRoom,
    /**
     * 业主信息
     */
    ownerInformation,
    /**
     * 查询信息
     */
    queryInformation,
    /**
     * 绑定数量
     */
    bindInformation,
  };
}
